import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import Status from '../Status';

/**
 * @deprecated Please use Status from @fiverr-private/data_display package.
 */
const LowRiskStatus = () => (
  <Status type="success">
    <I18n k="statuses.lowRisk" />
  </Status>
);

LowRiskStatus.displayName = 'LowRiskStatus';

export default LowRiskStatus;
